import * as React from 'react';
import { connect } from 'react-redux';
import { ActionRequest } from '../actions';
import {
    BaseElement,
    BasePlayerContainer,
    Table,
} from '../components';
import { ContainerContext, mapProps } from './index';
import { formatDate, truncateNumber } from '../utils';
import { useNavigate, useParams } from 'react-router';
import { StateMap } from '../reducers';
import { QueryResult } from 'material-table';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props extends ContainerContext.Props {
    readonly playerId: string;
}

type DialogType = 'Create';
interface State {
    readonly openDialog: DialogType | null;
}

class Container extends BaseElement<Props, State> {
    state = {
        openDialog: null,
    };

    protected renderContainer(): React.JSX.Element {
        const { playerId } = this.props;

        return (
            <BasePlayerContainer
                {...this.props}
                styled={this.props.styled}
                title = {"Achievements"}
                playerId = {playerId}
                showSubTabs = {true}
            >
                {this.renderContent()}
            </BasePlayerContainer>
        );
    }

    private renderContent = () => {
        const columns = [
            { title: 'Id', field: 'id'},
            { title: 'Progress', field: 'progress'},
            { title: 'Completed', field: 'completed'},
            { title: 'Reward Collected', field: 'rewardCollected'},
        ];

        return (
            <Table
                styled={this.props.styled}
                columns={columns}
                data={this.getData}
                options={{
                    showTitle: false,
                    selection: false,
                    paging: true,
                    pageSize: 10,
                    pageSizeOptions: [5, 10, 30, 50, 100],
                    emptyRowsWhenPaging: false,
                    search: true,
                    sorting: false,
                    draggable: false,
                }}
            />
        );
    };

    private getData = async (query: any): Promise<QueryResult<any>> => {
        const { playerId } = this.props;
        if (!playerId) {
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
        const { search, page, pageSize, orderBy, orderDirection } = query;
        const params = {
            search,
            page: page + 1,
            perPage: pageSize,
            orderBy: orderBy ? orderBy.field : null,
            orderDirection: orderDirection !== "" ? orderDirection : null,
        };
        const result = await ActionRequest.get(`player/${playerId}/achievements`, params);
        if (!result) {
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
        const data = result.entities.map((e: Entities.PlayerAchievement) => {
            return {
                entity: e,
                id: e.achievementId,
                progress: truncateNumber(e.progress),
                completed: e.completedTimestamp ? formatDate(e.completedTimestamp) : '',
                rewardCollected: e.rewardCollectedTimestamp ? formatDate(e.rewardCollectedTimestamp) : '',
            };
        });

        return {
            data,
            page: result.page - 1,
            totalCount: result.totalCount,
        };
    }
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
    playerId: '',
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    const params = useParams();
    const playerId = params.playerId || '';
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate} playerId={playerId}/>);
};
export default connect(mapStateToProps)(AppContainer);
